module.exports = __webpack_public_path__ + "static/media/checks.ee80f1e6.svg";